"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _globalComponentsLibrary = require("global-components-library");
var _types = require("../../utils/types");
var _constants = require("../../utils/constants");
var _Stopwatch = _interopRequireDefault(require("../common/Stopwatch/Stopwatch"));
var _ContactData = _interopRequireDefault(require("../common/ContactData/ContactData"));
var _helpers = require("../../utils/helpers");
require("./ConversationHeader.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ConversationHeader = function ConversationHeader(_ref) {
  var type = _ref.type,
    _ref$contact = _ref.contact,
    _ref$contact2 = _ref$contact === void 0 ? {} : _ref$contact,
    image = _ref$contact2.image,
    name = _ref$contact2.name,
    account = _ref$contact2.account,
    subject = _ref.subject,
    initialTime = _ref.initialTime,
    onViewContact = _ref.onViewContact,
    onFinish = _ref.onFinish,
    onUnassign = _ref.onUnassign,
    onSpam = _ref.onSpam,
    onDiscard = _ref.onDiscard,
    chatStarted = _ref.chatStarted,
    timeoutReached = _ref.timeoutReached,
    onDialog = _ref.onDialog,
    disabledActions = _ref.disabledActions;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDialogOpen = _useState2[0],
    setDialogOpen = _useState2[1];
  var dialogData = (0, _react.useRef)({});
  var _useTranslation = (0, _reactI18next.useTranslation)(['header', 'commons']),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    if (timeoutReached && chatStarted) {
      setTimeout(function () {
        onDialog && onDialog();
        setTimeout(function () {
          onFinish();
        }, 500);
      }, 500);
    }
  }, [timeoutReached, chatStarted]);
  var openDialog = function openDialog(action, type) {
    dialogData.current = {
      action: action,
      type: type
    };
    setDialogOpen(true);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-conv-header"
  }, type === 'MAIL' ? /*#__PURE__*/_react["default"].createElement("h6", {
    className: "uin-conv-subject"
  }, subject) : /*#__PURE__*/_react["default"].createElement(_ContactData["default"], {
    image: image,
    name: name,
    account: account
  }), initialTime != null && /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-conv-time"
  }, t('time'), ":", (0, _helpers.isNewMedia)(type) && !chatStarted ? /*#__PURE__*/_react["default"].createElement("b", null, "00:00") : /*#__PURE__*/_react["default"].createElement("b", null, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], {
    initialTime: initialTime
  }))), (!(0, _helpers.isNewMedia)(type) ? true : (0, _helpers.isNewMedia)(type) && chatStarted) && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DropDownMenu, {
    disabled: disabledActions
  }, onViewContact && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Option, {
    onClick: onViewContact
  }, t('view-contact.action')), onFinish && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Option, {
    onClick: function onClick() {
      return openDialog(onFinish, 'finish');
    }
  }, t('finish.action')), onUnassign && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Option, {
    onClick: function onClick() {
      return openDialog(onUnassign, 'unassign');
    }
  }, t('unassign.action')), onSpam && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Option, {
    onClick: function onClick() {
      return openDialog(onSpam, 'spam');
    }
  }, t('spam.action')), onDiscard && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Option, {
    onClick: function onClick() {
      return openDialog(onDiscard, 'discard');
    }
  }, t('discard.action'))), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DialogBox, {
    show: isDialogOpen,
    toggle: function toggle() {
      return setDialogOpen(!isDialogOpen);
    },
    onAccept: dialogData.current.action,
    title: t(dialogData.current.type + '.title'),
    content: t(dialogData.current.type + '.content'),
    accept: t(dialogData.current.type + '.commit'),
    cancel: t('commons:cancel')
  }));
};
ConversationHeader.propTypes = {
  conversationId: _propTypes["default"].number,
  type: _propTypes["default"].oneOf(Object.values(_constants.TABS)),
  contact: _propTypes["default"].shape({
    image: _propTypes["default"].element,
    name: _propTypes["default"].string,
    account: _propTypes["default"].string
  }),
  subject: _propTypes["default"].string,
  initialTime: _propTypes["default"].object,
  onFinish: _propTypes["default"].func,
  onUnassign: _propTypes["default"].func,
  onSpam: _propTypes["default"].func,
  onDiscard: _propTypes["default"].func
};
ConversationHeader.defaultProps = {
  type: _constants.TABS.HOME
};
var _default = exports["default"] = ConversationHeader;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ConversationHeader/ConversationHeader.js
// module id = 1398
// module chunks = 0